import React from "react";

const TemperatureBar = ({
  minTemp,
  maxTemp,
  globalMinTemp,
  globalMaxTemp,
  className = "",
}) => {
  // Calculate the range for the temperature bar
  const range = globalMaxTemp - globalMinTemp + 10; // Add padding

  // Calculate the bar styles
  const barStyles = {
    width: `${((maxTemp - minTemp) / range) * 100}%`,
    marginLeft: `${((minTemp - globalMinTemp) / range) * 100}%`,
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-gray-400">{Math.round(minTemp)}°</span>
      <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="h-full  bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] rounded-full"
          style={barStyles}
        />
      </div>
      <span className="text-sm text-gray-400">{Math.round(maxTemp)}°</span>
    </div>
  );
};

export default TemperatureBar;
